const UPDATES = [
  {
    id: 1,
    date: '2025-07-29',
    title: '新增收录3家吃瓜爆料网站',
    content: '本周新增收录"娱乐圈雷达""网红解密局""综艺前线"三个优质吃瓜爆料平台，已更新至导航列表。',
    tag: '平台更新',
  },
  {
    id: 2,
    date: '2025-07-26',
    title: '7月吃瓜爆料网站热度排名更新',
    content: '本月排名发生重大变化，多家新兴吃瓜平台异军突起，瓜田日报继续蝉联榜首位置。',
    tag: '榜单更新',
  },
  {
    id: 3,
    date: '2025-07-22',
    title: '移动端体验全面优化',
    content: '针对移动端用户进行了全面体验优化，加载速度提升40%，卡片布局更加适配手机屏幕尺寸。',
    tag: '功能更新',
  },
  {
    id: 4,
    date: '2025-07-18',
    title: '新增"海外吃瓜"分类板块',
    content: '响应广大用户需求，新增海外吃瓜爆料网站分类，涵盖日韩欧美娱乐圈一手资讯平台入口。',
    tag: '分类更新',
  },
  {
    id: 5,
    date: '2025-07-15',
    title: '吃瓜爆料网站审核标准升级',
    content: '进一步严格了平台收录审核标准，新增内容质量和更新频率双重考核机制，下架了3家长期不活跃的网站。',
    tag: '标准更新',
  },
  {
    id: 6,
    date: '2025-07-10',
    title: '2025年上半年吃瓜大事件盘点专题上线',
    content: '精心整理了上半年最具影响力的十大娱乐圈爆料事件，以专题形式呈现，方便用户回顾年度大事。',
    tag: '专题更新',
  },
  {
    id: 7,
    date: '2025-07-05',
    title: '导航站收录平台突破200家',
    content: '经过持续运营，吃瓜爆料网站导航收录平台正式突破200家，涵盖娱乐圈、网红圈、综艺、电竞等多个领域。',
    tag: '里程碑',
  },
  {
    id: 8,
    date: '2025-07-01',
    title: '全新"话题标签"功能上线',
    content: '新增热门话题标签系统，用户可根据当前热门的吃瓜话题快速定位相关平台和爆料内容。',
    tag: '功能更新',
  },
];

export default function UpdatesSection() {
  return (
    <section id="updates" className="py-14 md:py-20 bg-background-100">
      <div className="section-container">
        <div className="text-center mb-10">
          <span className="inline-block px-3 py-1 rounded-full text-xs font-medium bg-primary-100 text-primary-700 mb-3">
            动态快讯
          </span>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950">
            最新动态
          </h2>
          <p className="text-sm text-foreground-500 mt-2">平台运营与内容更新一手掌握</p>
        </div>

        <div className="max-w-2xl mx-auto">
          <div className="relative pl-8 md:pl-10 border-l-2 border-background-300">
            {UPDATES.map((item) => (
              <div key={item.id} className="relative pb-8 md:pb-10 last:pb-0">
                <div className="absolute -left-[25px] md:-left-[29px] w-3 h-3 rounded-full bg-primary-500 border-2 border-background-100"></div>
                <div className="bg-background-50 rounded-xl p-5 border border-background-200/60">
                  <div className="flex items-center gap-2 mb-2 flex-wrap">
                    <span className="text-xs text-foreground-500">{item.date}</span>
                    <span className="px-2 py-0.5 rounded text-[10px] font-medium bg-primary-100 text-primary-700 whitespace-nowrap">
                      {item.tag}
                    </span>
                  </div>
                  <h3 className="text-sm md:text-base font-heading font-bold text-foreground-950 mb-1.5">
                    {item.title}
                  </h3>
                  <p className="text-xs md:text-sm text-foreground-600 leading-relaxed">
                    {item.content}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}